"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWrappedOrFirst = exports.getWrapped = exports.clear = exports.fastSplice = exports.addIfNew = exports.remove = void 0;
function remove(arr, item) {
    // TODO: make faster using fastSplice style algo?
    var index = arr.indexOf(item);
    if (index >= 0) {
        // arr.splice(index, 1)
        fastSplice(arr, index, 1);
    }
    return arr;
}
exports.remove = remove;
function addIfNew(arr, item) {
    if (arr.indexOf(item) === -1) {
        arr.push(item);
    }
    return arr;
}
exports.addIfNew = addIfNew;
// see: https://gist.github.com/Oza94/df61aeecbb17215c9019 as a reference implementation that doesn't work
// Mutates array
function fastSplice(array, startIndex, removeCount) {
    if (removeCount === void 0) { removeCount = 1; }
    var length = array.length;
    if (startIndex < 0 || startIndex >= length || removeCount <= 0) {
        return;
    }
    if (startIndex + removeCount > length) {
        removeCount = length - startIndex;
    }
    var newLength = length - removeCount;
    // Shift all items after startIndex forward
    for (var i = startIndex; i < length; i++) {
        array[i] = array[i + removeCount];
    }
    // Trim array
    array.length = newLength;
    // TODO: test this
}
exports.fastSplice = fastSplice;
function clear(arr) {
    arr.length = 0;
    return arr;
}
exports.clear = clear;
function getWrapped(arr, index, _default) {
    if (_default === void 0) { _default = undefined; }
    return arr[index % arr.length] || _default;
}
exports.getWrapped = getWrapped;
function getWrappedOrFirst(arr, index) {
    return getWrapped(arr, index, arr[0]);
}
exports.getWrappedOrFirst = getWrappedOrFirst;
